/**
 * Recruitment › Settings — a nav group's settings, not a module's, so it nests under the GROUP's
 * name the way Organization's does. The catalog behind it is reached only through this menu.
 */
export const RECRUITMENT_SETTINGS_PATH = '/recruitment/settings';

export const APPLICANT_REQUIREMENTS_PATH = `${RECRUITMENT_SETTINGS_PATH}/applicant-requirements`;

export const SCORE_POINTS_PATH = `${RECRUITMENT_SETTINGS_PATH}/score-points`;
